













import { BSpinner } from "bootstrap-vue";
import { defineComponent, ref } from "@vue/composition-api";
import useUsers from "./useUsers";

export default defineComponent({
    components: {
        BSpinner,
    },
    setup() {
        const { limits, fetchLimits, isLoadingLimits } = useUsers();

        fetchLimits();

        return {
            userLimits: limits,
            isLoading: isLoadingLimits,
        };
    },
});
